export default {
  namespaced: true,
  state: {
    request: null,
    response: null,
  },
  getters: {
    ReqResp (state) {
      return {
        request: state.request,
        response: state.response,
      }
    },
  },
  actions: {
    ReqResp ({ commit }, ReqResp) {
      commit('attRequest', ReqResp.request)
      commit('attResponse', ReqResp.response)
    },
  },
  mutations: {
    attRequest (state, request) {
      state.request = request
    },
    attResponse (state, response) {
      state.response = response
    },
  },
}
